const activeButtonEquipStatusBtn = {
  true: 'Inativar',
  false: 'Reativar',
  label: ' Equipamento'
};

export default activeButtonEquipStatusBtn;
